import { TemplatesState } from '../templates/types';

export const getGallery = (state: any): TemplatesState => state.gallery;
export const isGalleryLoading = (state: any): TemplatesState['loadingData'] => state.gallery.loadingData;
